import { useContext, useMemo } from 'react';
import ProjectNewsContext from '../context/ProjectNewsContext';
import { ProjectId } from '../../../models/Types';

const useProjectNewsContext = (projectId?: ProjectId) => {
  const context = useContext(ProjectNewsContext);

  return useMemo(() => {
    return {
      ...context,
      ...(projectId
        ? {
            projectNews: context.getProjectNewsByProjectId(projectId),
            projectNewsCounts:
              context.getProjectNewsCountsByProjectId(projectId),
          }
        : {}),
    };
  }, [context, projectId]);
};

export default useProjectNewsContext;
